import { createAsyncThunk } from "@reduxjs/toolkit";
import { BandExportService } from "Bands/services/BandExportService";
import { BAND_ACTIONS, IBandXlsParams } from "Bands/types";
import { IDataKeys } from "shared/types";

export const createBandExport = createAsyncThunk(
  BAND_ACTIONS.createBandExport,
  async (
    {
      data,
    }: {
      data: IBandXlsParams;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await BandExportService.createEventExport({
        data,
      });

      const downloadUrl = (Object.values(response?.[IDataKeys.eventsExport])[0] as any)?.attributes
        ?.export?.downloadUrl;

      window.location.href = downloadUrl;

      // keep the key even if response is empty
      return {
        [IDataKeys.eventsExportConfig]: response.eventsExport,
        meta: response.meta,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
